import { render, staticRenderFns } from "./ChangeDeliveryButton.vue?vue&type=template&id=6079fce8&scoped=true&lang=pug"
import script from "./ChangeDeliveryButton.vue?vue&type=script&lang=js"
export * from "./ChangeDeliveryButton.vue?vue&type=script&lang=js"
import style0 from "./ChangeDeliveryButton.vue?vue&type=style&index=0&id=6079fce8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6079fce8",
  null
  
)

export default component.exports